export default __webpack_public_path__ + "static/media/PICK-UP.d3e528db.svg";